import { classed } from "@/components/classed.config";

export const Badge = classed.div(
  "inline-flex items-center whitespace-nowrap tracking-wide rounded-sm border px-1.5 py-px text-1xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow-sm",
        secondary:
          "border-transparent bg-gray-100 text-foreground dark:bg-gray-700 dark:text-gray-200",
        tertiary:
          "border-transparent bg-indigo-100 text-indigo-500 dark:bg-indigo-800 dark:text-indigo-200",
        quaternary:
          "border-transparent bg-emerald-100 text-emerald-600 dark:bg-emerald-800 dark:text-emerald-200",
        outline: "text-foreground",
        info: "border-transparent bg-blue-100 text-blue-600 dark:bg-blue-800 dark:text-blue-200",
        success:
          "border-transparent bg-green-100 text-green-800 dark:bg-green-900 dark:text-white",
        danger: "border-transparent bg-destructive text-destructive-foreground",
        warning:
          "border-transparent bg-yellow-100 text-yellow-600 dark:bg-yellow-800 dark:text-yellow-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
